import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import TicketCategoryForm from '@/modules/ticket_category/components/TicketCategoryForm.vue';
import { TicketCategory } from '@/modules/ticket_category/TicketCategory';


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketCategoryCreate',
  setup(__props) {

const { $gettext } = useGettext();
const router = useRouter();
const ticketCategory = ref<Partial<TicketCategory>>({
	content: [],
});

const saved = (ticket_category) => {
	Flash.success($gettext('Kategori tillagd'));
	router.push({
		name: 'ticket_category.edit',
		params: { id: ticket_category.id },
	});
};

const cancel = () => {
	router.push({ name: 'ticket_category.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TicketCategoryForm, {
    "page-title": _unref($gettext)('Ny kategori'),
    "ticket-category": ticketCategory.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["page-title", "ticket-category"]))
}
}

})